import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectPermittedActions } from "../ui/permittedActionsReducer";
import { Tabs, Tab } from 'react-bootstrap'
import { resetTabQueryParams } from "../ui/customerListingReducer";

const TabsComponent = (props) => {
  const dispatch = useDispatch();
  const [tabs, setTabs] = useState([])
  const [activeKey, setActiveKey] = useState(props.defaultActiveEvent)
  const permittedActions = useSelector(selectPermittedActions);

  useEffect(() => {
    dispatch(resetTabQueryParams());
    const permittedTabs = props.data.filter((tab_data) => permittedActions.permittedActions.indexOf(tab_data.ui_action) !== -1)
    setTabs(permittedTabs);
  }, [props.data])

  const onTabChange = (key) => {
    setActiveKey(key);
    dispatch(resetTabQueryParams());
  }

  return (
    <>
      <Tabs onSelect={onTabChange} activeKey={activeKey} unmountOnExit={true} variant="tabs" mountOnEnter={true} defaultActiveKey={props.defaultActiveEvent || ""} id="uncontrolled-tab-example">
        {tabs.map((tab) => {
          return <Tab
            key={tab.event}
            eventKey={tab.event}
            title={tab.heading}>
            {tab.component}
          </Tab>
        })}
      </Tabs>
    </>
  )
};

export default TabsComponent;



